<div class="row">
    <div class="col-lg-6 page-title mb-4 pb-3">
        {{'requests.clientData.newRequest.Title' | translate}}
    </div>
</div>
<div class="request-details-container d-flex flex-column">
    <div class="request-card ccc">
        <button class="btn link-btn btn-back-txt" (click)="redirectListHandler()">
            <i class="app-icon icon icon-arrow-left icon-xl me-2"></i>
            <span>{{'requests.clientData.newRequest.BackToRequestList' | translate}}</span>
        </button>

        <div class="d-flex justify-content-center mt-3 mb-5">
            <div class="section-subtitle fw-semibold">
                {{'requests.clientData.newRequest.Subtitle' | translate}}
            </div>
        </div>

        <form>
            <ng-container *ngFor="let requestType of requestTypes">
                <div class="row justify-content-center">
                    <div class="col-md-6 col-lg-4 col-xl-4 col-xxxl-3 radio-container"
                        [ngClass]="{'textarea-option' : requestType.code === requestTypeCodes.Other,
                            'bank-account-option' : requestType.code === requestTypeCodes.BankAccount
                        }"
                        [hidden]="
                        (!isPJ && requestType.forLegalOnly) ||
                        (!isPJ && requestType.code === requestTypeCodes.CompanyInfo) ||
                        (isPJ  && requestType.code === requestTypeCodes.PersonalInfo)">

                        <input class="radio-input" type="radio" kendoRadioButton size="large"
                            name="radio-{{requestType.code}}"
                            id="radio-{{requestType.code}}"
                            [(ngModel)]="clientDataRequestSaveModel.dictionaryClientDataRequestTypeId"
                            (ngModelChange)="clientDataRequestTypeChangedHandler()"
                            [value]="requestType.id">

                        <label class="radio-label" for="radio-{{requestType.code}}">
                            <div class="d-flex flex-column w-100">
                                <div class="fw-bold text-start">
                                    {{requestType.value}}
                                </div>

                                <kendo-textarea
                                    [placeholder]="'requests.clientData.newRequest.otherPlaceholder' | translate" class="textarea-input"
                                    name="other-textarea" resizable="vertical" [cols]="30"
                                    *ngIf="requestType.code === requestTypeCodes.Other"
                                    [(ngModel)]="clientDataRequestSaveModel.otherField" (ngModelChange)="textAreaInputHandler()"
                                    [required]="requestType.code === requestTypeCodes.Other">
                                </kendo-textarea>

                                <div 
                                    *ngIf="requestType.code === requestTypeCodes.BankAccount && 
                                        clientDataRequestSaveModel.dictionaryClientDataRequestTypeId === requestType.id" 
                                    class="mt-3"
                                >
                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <label class="form-label text-main fw-bold me-1 mb-0" for="iban-textbox">
                                            {{ 'requests.clientData.newRequest.iban' | translate }}
                                        </label>
                                        <kendo-textbox
                                            id="iban-textbox"
                                            name="iban"
                                            class="bank-account-textbox"
                                            [placeholder]="'requests.clientData.newRequest.enterIban' | translate"
                                            [(ngModel)]="clientDataRequestSaveModel.ibanField"
                                            (ngModelChange)="bankAccountInputHandler()"
                                            [required]="requestType.code === requestTypeCodes.BankAccount">
                                        </kendo-textbox>
                                    </div>

                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <label class="form-label text-main fw-bold me-1 mb-0" for="bank-textbox">
                                            {{ 'requests.clientData.newRequest.bank' | translate }}
                                        </label>
                                        <kendo-textbox
                                            id="bank-textbox"
                                            name="bankName"
                                            class="bank-account-textbox"
                                            [placeholder]="'requests.clientData.newRequest.enterBankName' | translate"
                                            [(ngModel)]="clientDataRequestSaveModel.bankName"
                                            (ngModelChange)="bankAccountInputHandler()"
                                            [required]="requestType.code === requestTypeCodes.BankAccount">
                                        </kendo-textbox>
                                    </div>
                                </div>
                            </div>
                        </label>
                    </div>
                </div>
            </ng-container>
            <div class="row justify-content-center mt-2">
                <client-data-request-uploader *ngIf="clientDataRequestSaveModel.dictionaryClientDataRequestTypeCode === requestTypeCodes.Other 
                                                    || clientDataRequestSaveModel.dictionaryClientDataRequestTypeCode === requestTypeCodes.BankAccount"
                    [clientDataRequest]="clientDataRequestSaveModel"
                    [deleteFileHandler]="_filesHandler.deleteFileHandler"
                    [uploadFilesHandler]="_filesHandler.uploadFilesHandler"
                    class="col-md-6 col-lg-4 col-xl-4 col-xxxl-3"
                >
                </client-data-request-uploader>
            </div>
        </form>

        <div class="d-flex justify-content-center my-4 py-3">
            <button class="btn primary-btn btn-next" 
                (click)="redirectSelectionHandler()" [disabled]="isSendButtonDisabled">
                {{ 'requests.clientData.newRequest.Next' | translate}}
            </button>
        </div>
    </div>
</div>
